// import React from 'react'


// const FunFact = (props) => {
//     // THESE ARE REAL NUMBERS FOR  MAAK DEVELOPERS
//     const funfact = [
//         {
//             title: '70+',
//             subTitle: 'Years Of Experience',
//         },
//         {
//             title: '80+',
//             subTitle: 'Expert Specialists',
//         },
//         {
//             title: '20+',
//             subTitle: 'Successful Projects',
//         },
//         {
//             title: '1100+',
//             subTitle: 'Happy Customers',
//         },
//         {
//             title: '5+',
//             subTitle: 'Global Presence Countries',
//         },
//     ]


//     return (

//         <section className={`wpo-fun-fact-section pb-120 ${props.fnClass}`}>
//             <div className="container">
//                 <div className="row mt-5">
//                     <div className="col col-xs-12 mt-5">
//                         <div className="wpo-fun-fact-grids clearfix" style={{
//                             display: 'flex',
//                             flexWrap: 'nowrap',
//                             justifyContent: 'space-between',
//                             alignItems: 'center',
//                             gap: '20px'
//                         }}>
//                             {funfact.map((funfact, fitem) => (
//                                 <div className="grid" key={fitem} style={{
//                                     flex: '1',
//                                     minWidth: '0',
//                                     textAlign: 'center'
//                                 }}>
//                                     <div className="info">
//                                         <h3 style={{
//                                             fontSize: 'clamp(24px, 4vw, 60px)',
//                                             margin: '0 0 0.2em',
//                                             lineHeight: '1.2'
//                                         }}>{funfact.title}</h3>
//                                         <p style={{
//                                             fontSize: 'clamp(12px, 2vw, 20px)',
//                                             margin: '0',
//                                             lineHeight: '1.3',
//                                             wordWrap: 'break-word'
//                                         }}>{funfact.subTitle}</p>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     )
// }

// export default FunFact;



























import React, { useEffect, useState } from 'react';
import { getFunFacts } from '../../api/Home';

const FunFact = (props) => {
    const [facts, setFacts] = useState([]);

    useEffect(() => {
        const fetchFacts = async () => {
            try {
                const data = await getFunFacts();

                if (data) {
                    const mappedFacts = [
                        { title: data.title1, subTitle: data.subtitle1 },
                        { title: data.title2, subTitle: data.subtitle2 },
                        { title: data.title3, subTitle: data.subtitle3 },
                        { title: data.title4, subTitle: data.subtitle4 },
                        { title: data.title5, subTitle: data.subtitle5 },
                    ];

                    setFacts(mappedFacts);
                }
            } catch (error) {
                console.error("Error fetching fun facts:", error);
            }
        };

        fetchFacts();
    }, []);

    return (
        <section className={`wpo-fun-fact-section pb-120 ${props.fnClass}`}>
            <div className="container">
                <div className="row mt-5">
                    <div className="col col-xs-12 mt-5">
                        <div
                            className="wpo-fun-fact-grids clearfix"
                            style={{
                                display: 'flex',
                                flexWrap: 'nowrap',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: '20px'
                            }}
                        >
                            {facts.map((item, index) => (
                                <div
                                    className="grid"
                                    key={index}
                                    style={{
                                        flex: '1',
                                        minWidth: '0',
                                        textAlign: 'center'
                                    }}
                                >
                                    <div className="info">
                                        <h3
                                            style={{
                                                fontSize: 'clamp(24px, 4vw, 60px)',
                                                margin: '0 0 0.2em',
                                                lineHeight: '1.2'
                                            }}
                                        >
                                            {item.title}
                                        </h3>
                                        <p
                                            style={{
                                                fontSize: 'clamp(12px, 2vw, 20px)',
                                                margin: '0',
                                                lineHeight: '1.3',
                                                wordWrap: 'break-word'
                                            }}
                                        >
                                            {item.subTitle}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FunFact;
